module.exports = __webpack_public_path__ + "static/Fellix-Medium-bad33dbb2ebae08a8b32ffe20e143730.woff2";